import { render, staticRenderFns } from "./praticeCon.vue?vue&type=template&id=f9febcac&scoped=true&"
import script from "./praticeCon.vue?vue&type=script&lang=js&"
export * from "./praticeCon.vue?vue&type=script&lang=js&"
import style0 from "./praticeCon.vue?vue&type=style&index=0&id=f9febcac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9febcac",
  null
  
)

export default component.exports